import { type PropsWithChildren, type ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Drawer as MantineDrawer, type DrawerProps } from '@mantine/core';

import { POSTHOG_EVENTS } from '@/lib/posthog/events';
import { trackEvent } from '@/lib/posthog/helpers';

import classes from './Drawer.module.css';

interface MercuryDrawer extends PropsWithChildren, DrawerProps {
  title?: string;
  link?: ReactNode;
  drawerid?: any;
}

const Drawer = ({
  title,
  link,
  drawerid,
  opened,
  children,
  position = 'right',
  size = 'lg',
  ...drawerProps
}: MercuryDrawer) => {
  const location = useLocation();

  useEffect(() => {
    if (opened) {
      drawerProps.onClose();
    }
  }, [location]);

  return (
    <MantineDrawer.Root
      opened={opened}
      lockScroll={false}
      radius={0}
      offset={0}
      position={position}
      size={size}
      {...drawerProps}
      classNames={{
        content: classes.content,
        inner: classes.inner,
        title: classes.title,
        body: classes.body,
        header: `${link ? classes.headerWithLink : ''}`,
      }}
    >
      <MantineDrawer.Content>
        <MantineDrawer.Header>
          <div className={`${link ? classes.titleWrapper : ''}`}>
            <MantineDrawer.Title>{title}</MantineDrawer.Title>
            {link && (
              <span
                role="presentation"
                onClick={() =>
                  trackEvent(POSTHOG_EVENTS.SIDEPANEL_EXPAND, {
                    source: window.location.pathname,
                    drawerid: String(drawerid ?? ''),
                  })
                }
              >
                {link}
              </span>
            )}
          </div>
          <MantineDrawer.CloseButton aria-label="Close Drawer" />
        </MantineDrawer.Header>
        <MantineDrawer.Body>{children}</MantineDrawer.Body>
      </MantineDrawer.Content>
    </MantineDrawer.Root>
  );
};

export default Drawer;
